/* The two documents: one glass sheet of prose on the same studio stage. */

.page {
  position: relative;
  z-index: 2;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: calc(18px + var(--safe-t)) 16px calc(40px + var(--safe-b));
}

.bar {
  width: min(760px, 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* The account pill's shape, as a real link: it is navigation, not a button. */
.back {
  text-decoration: none;
  color: var(--ink);
}

.mark {
  width: 34px;
  height: 34px;
  display: block;
  opacity: 0.9;
}

.doc {
  width: min(760px, 100%);
  border-radius: var(--r-xl);
  padding: 36px 40px 40px;
  box-shadow: var(--shadow-3);
}

.eyebrow {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: var(--accent-deep);
}

.title {
  margin: 9px 0 7px;
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -0.035em;
  color: var(--ink);
}

.updated {
  margin: 0;
  font-size: 13px;
  color: var(--ink-3);
}

/* The summary a reader deserves before the prose: what the app does not do. */
.facts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 26px 0 2px;
}

.fact {
  padding: 12px 14px;
  border-radius: var(--r-sm);
  background: rgba(255, 255, 255, 0.55);
  box-shadow: inset 0 0 0 0.5px var(--hairline);
}

.factTitle {
  font-size: 13.5px;
  font-weight: 650;
  color: var(--ink);
  letter-spacing: -0.015em;
}

.factSub {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ink-3);
}

.prose {
  font-size: 15px;
  line-height: 1.62;
  letter-spacing: -0.01em;
  color: var(--ink-2);
}

.prose h2 {
  margin: 28px 0 10px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ink);
}

.prose p {
  margin: 0 0 12px;
}

.prose ul {
  margin: 0 0 14px;
  padding-left: 19px;
}

.prose li {
  margin: 0 0 7px;
}

.prose strong {
  color: var(--ink);
  font-weight: 620;
}

.prose code {
  font-family: var(--mono);
  font-size: 12.5px;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(11, 31, 23, 0.055);
  color: var(--ink);
}

.prose a,
.links a {
  color: var(--accent-deep);
  font-weight: 560;
  text-underline-offset: 2px;
  text-decoration-color: var(--accent-glow);
}

.foot {
  margin-top: 28px;
  padding-top: 18px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px 18px;
  box-shadow: 0 -0.5px 0 var(--hairline);
  font-size: 13px;
  color: var(--ink-3);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

@media (max-width: 620px) {
  .doc {
    padding: 26px 22px 30px;
    border-radius: var(--r-lg);
  }

  .title {
    font-size: 27px;
  }

  .facts {
    grid-template-columns: 1fr;
  }
}
